import React from 'react'
import Loading from '../components/elements/loading-init'

const LoadingInitContainer = () => {
    return <Loading />
}

export default LoadingInitContainer
